import { QueryClientProvider } from '@tanstack/react-query'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router'
import { App } from './App'
import { AuthProvider } from './hooks/useAuth'
import { ToastProvider } from './hooks/useToast'
import { createQueryClient } from './lib/queryClient'
import { registerServiceWorker } from './lib/push'
import './index.css'

const container = document.getElementById('root')
if (!container) throw new Error('Missing #root element')

const queryClient = createQueryClient()

createRoot(container).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      {/* AuthProvider needs the router (it redirects on 401) and the toaster. */}
      <BrowserRouter>
        <ToastProvider>
          <AuthProvider>
            <App />
          </AuthProvider>
        </ToastProvider>
      </BrowserRouter>
    </QueryClientProvider>
  </StrictMode>,
)

// Registered eagerly so an already-granted push subscription keeps working after
// a deploy, even if the user never opens the account page.
void registerServiceWorker()
